import { render, staticRenderFns } from "./PEPUpload.vue?vue&type=template&id=2c5dc113&"
import script from "./PEPUpload.vue?vue&type=script&lang=ts&"
export * from "./PEPUpload.vue?vue&type=script&lang=ts&"
import style0 from "./PEPUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports